import { useState, useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { BulkUploader } from "@/components/BulkUploader";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/components/ui/use-toast";

export default function BulkUpload() {
  const [isAdmin, setIsAdmin] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    console.log("BulkUpload component mounted");
    checkAdminStatus();
  }, []);

  const checkAdminStatus = async () => {
    console.log("Starting admin status check...");
    try {
      const { data: { user }, error: userError } = await supabase.auth.getUser();
      
      if (userError) {
        console.error("Error getting user:", userError);
        throw userError;
      }

      if (!user) {
        console.log("No user found, redirecting to auth");
        navigate("/auth");
        return;
      }

      console.log("Current user:", user);
      console.log("Checking admin status for user:", user.id);

      const { data: roles, error: rolesError } = await supabase
        .from('user_roles')
        .select('*')
        .eq('user_id', user.id)
        .single();

      if (rolesError) {
        console.error('Error fetching user role:', rolesError);
        throw rolesError;
      }

      console.log("User roles data:", roles);

      if (roles?.role !== 'admin') {
        console.log("User is not admin. Role:", roles?.role);
        toast({
          title: "Access Denied",
          description: "You need admin privileges to access this page",
          variant: "destructive",
        });
        navigate("/templates");
        return;
      }

      console.log("User confirmed as admin");
      setIsAdmin(true);
    } catch (error) {
      console.error('Error checking admin status:', error);
      console.log('Full error object:', JSON.stringify(error, null, 2));
      toast({
        title: "Error",
        description: "Failed to verify admin status",
        variant: "destructive",
      });
      navigate("/templates");
    } finally {
      console.log("Admin check completed. isAdmin:", isAdmin);
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-lg">Loading...</div>
      </div>
    );
  }

  if (!isAdmin) {
    return null;
  }

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold mb-6">Bulk Upload Documents</h1>
      <Card className="w-full max-w-2xl mx-auto">
        <CardHeader>
          <CardTitle className="text-2xl font-bold">Upload Multiple Documents</CardTitle>
        </CardHeader>
        <CardContent>
          <BulkUploader />
        </CardContent>
      </Card>
    </div>
  );
}